import { useEffect, useState } from 'react';
import { CalendarIcon, GridIcon, listIcon } from '../../assets/images';
import { ESystemName } from '../../constants';
import { useAppSelector } from '../../store/hooks';
import { MuiIconButton } from './iconButtonComponent';
import { MuiStack } from './stackComponent';
var ToggleIconButtonComponent = function (props) {
    var activeView = props.activeView, onToggleView = props.onToggleView, moduleName = props.moduleName;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _a = useState([{
            name: 'list',
            icon: listIcon
        }, {
            name: 'calendar',
            icon: CalendarIcon
        }, {
            name: 'grid',
            icon: GridIcon
        }]), toggleButtonsList = _a[0], setToggleButtonsList = _a[1];
    useEffect(function () {
        if (moduleName !== ESystemName.Appointment) {
            setToggleButtonsList(toggleButtonsList.filter(function (item) { return item.name !== "calendar"; }));
            if (activeView === 'calendar') {
                var _toggleButtonsList$;
                onToggleView((_toggleButtonsList$ = toggleButtonsList[0]) === null || _toggleButtonsList$ === void 0 ? void 0 : _toggleButtonsList$.name);
            }
        }
    }, [moduleName]);
    var handleToggleView = function (view) {
        if (view !== activeView) {
            onToggleView(view);
        }
    };
    return /*#__PURE__*/ React.createElement(MuiStack, null, 
    /*#__PURE__*/
    // !loader.isLoaderOpen ?
    React.createElement(React.Fragment, null, toggleButtonsList.map(function (item, index) { /*#__PURE__*/ return React.createElement(MuiStack, {
        key: index,
        style: {
            backgroundColor: activeView === item.name ? '#ffffff' : '#EFF2F5',
            borderRadius: '4px',
            height: '35px'
        }
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "".concat(item.name, "-button"),
        disabled: loader.isLoaderOpen,
        onClick: function () { return handleToggleView(item.name); }
    }, /*#__PURE__*/ React.createElement("img", {
        id: item.name,
        src: item.icon,
        alt: item.name
    }))); }))
    // :
    // <Stack width='112px' height='100%' >
    //   <SkeletonLoader />
    // </Stack>
    );
};
export default ToggleIconButtonComponent;
